export const xBridgeAddress = '0xE4200cbf10ea0D3F8FE35B59cF9fCF21e911a743';
export const eBridgeAddress = '0x19dcc5d3753404db0b98016f32557a9f3b54572a';
export const deployee       = '0xeB186e9BA850a710FaA241E48770D5260f9b0ab6';
export const tokenAddress   = "0xdf1Efd50Fc91b377DA328F42f408f3BF904143D0";
export const tokenBridge    = '0xeAe46f035CfAA057D31F9a3777285beC69d9679C';
export const tokenDeployee  = '0xA6B1E581234E95963148E6Ea5Bbf9410C7971061';

export const NETWORKS = {
    XDC_MAINNET: "XDC Mainnet",
    XDC_APOTHEM_TESTNET: "XDC Apothem Testnet",
};